import * as React from "react";
import Slider from "@mui/material/Slider";
export default function SliderSizes(props) {
  let myArr = props.mark;
  const marks =
    myArr &&
    myArr.map(function (i) {
      var data = {
        value: i.value,
        label: i.label,
      };
      return data;
    });
  return (
    <>
      <Slider
      disabled
        defaultValue={props.value}
        aria-label="Default"
        valueLabelDisplay="auto"
        marks={marks}
        style={{ color: `${props.color}` }}
      />
    </>
  );
}
